
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.344 8.867c.932 1.047 2.161 1.57 3.687 1.57.792 0 1.474-.13 2.047-.39.573-.266 1.094-.677 1.563-1.235h1.226v.438c-1.182 1.245-2.836 1.867-4.96 1.867-1.693 0-3.139-.497-4.337-1.492-1.192-1-1.789-2.32-1.789-3.96 0-1.647.597-2.964 1.79-3.954C3.762.72 5.246.227 7.022.227c1.771 0 3.22.526 4.344 1.578 1.125 1.052 1.688 2.43 1.688 4.133H3.344v2.93zm7.242-6.328c-.375-.39-.737-.7-1.086-.93a3.899 3.899 0 00-1.148-.523 5.12 5.12 0 00-1.415-.18c-.515 0-.981.063-1.398.188-.411.12-.789.294-1.133.523-.343.23-.698.537-1.062.922v2.703h7.242V2.54z","fill":"currentColor"}})])
          )
        }
      }
    